import React from "react";
import style from "./index.module.scss";
import { Button } from "antd";
import className from "classnames";
import { TopicsItem } from "../../../../../API/exercise";
import useDeviceType from "../../../../../Utils/useDeviceType";
import classNames from "classnames";

interface ExerciseBarProps {
    checked: number;
    data: TopicsItem[];
    onChange: (val: number) => void;
    onClose?: () => void;
}

export default function ExerciseBar({
    checked,
    data,
    onChange,
    onClose
}: ExerciseBarProps) {
    const { isPC } = useDeviceType();

    return (
        <div className={style.root}>
            <div className={style.top}>
                <div className={style.title}>全部试题</div>

                <div className={style.icons}>
                    <span className={style.iconNone}>未答</span>
                    <span className={style.iconRight}>正确</span>
                    <span className={style.iconWrong}>错误</span>
                </div>
            </div>

            {/* 答题卡策略：
            已答--已批--正确，绿色
            已答--已批--错误，红色
            未答--未批--，白色
            未答--已批（给0分），-，白色
            未提交---都白色。学生答题卡，只要是未答的都是白色 */}
            <div className={classNames({ [style.body]: !isPC })}>
                <ul className={style.qidList}>
                    {data &&
                        data.map((item, index) => (
                            <li
                                onClick={() => onChange(item.index)}
                                key={index}
                                className={className(style.qidItem, {
                                    [style.current]: item.index === checked,
                                    [style.right]:
                                        item.stuIsRight === "1" &&
                                        item.stuFinishTopic === "1",
                                    [style.wrong]:
                                        item.stuIsRight === "0" &&
                                        item.stuFinishTopic === "1"
                                })}>
                                {item.index}
                            </li>
                        ))}
                </ul>
            </div>

            {!isPC && (
                <div className={style.footer}>
                    <Button block className={style.btn} onClick={onClose}>
                        返回
                    </Button>
                </div>
            )}
        </div>
    );
}
